const findLanguageList = (code) => {
  let info = {};
  if (code == 'fa') {
    info = {
      code: 'fa',
      array: [
        { text: 'فارسی', code: 'fa' },
        { text: 'انگلیسی', code: 'en' },
        { text: 'عربی', code: 'ar' },
      ],
    };
  }
  if (code == 'en') {
    info = {
      code: 'en',
      array: [
        { text: 'farsi', code: 'fa' },
        { text: 'english', code: 'en' },
        { text: 'arabic', code: 'ar' },
      ],
    };
  }
  if (code == 'ar') {
    info = {
      code: 'ar',
      array: [
        { text: 'فارسی', code: 'fa' },
        { text: 'إنجليزي', code: 'en' },
        { text: 'عربي', code: 'ar' },
      ],
    };
  }
  return info;
};
export default findLanguageList;
